// module.exports = {
//   appName: 'Пироговая лавка',
//   appUrl: 'http://91.240.85.64',
//   apiUrl: 'http://91.240.85.64/api'
// }
// module.exports = {
//   appName: 'Пироговая лавка',
//   appUrl: 'http://localhost',
//   apiUrl: 'http://localhost/api'
// }
module.exports = {
  appName: 'Пироговая лавка',
  appUrl: 'https://pirogovayalavka.ru',
  apiUrl: 'https://pirogovayalavka.ru/api'
}



// WEBPACK FOOTER //
// ./src/components/config.js